import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormField, FormFieldTypes } from 'src/app/shared/forms/abstract-form-field.directive';
import { FormContainerVM, FormFieldValue } from 'src/app/shared/forms/form-vm-container.directive';

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss']
})
export class TextAreaComponent extends FormField<string> {
  override updateModel(formVM: FormContainerVM, value: FormFieldValue): FormContainerVM {
    throw new Error('Method not implemented.');
  }

  override type: FormFieldTypes = 'text';


  @Input() scrollbar: boolean = true;
  @Input() className: string = '';
  @Input() width: string = '';
  @Input() height: string = '';
  @Input() value: string = '';

  @Output() onInput = new EventEmitter<string>()

  override ngOnInit(): void {
    super.ngOnInit()
    this.control.patchValue(this.value);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.control.patchValue(this.value)
    }
  }

  _change(s: string){
    this.model = s;
    this.onInput.emit(s)
  }

  autoResize(event: Event) {

    if (!this.scrollbar) {

      const textarea = event.target as HTMLTextAreaElement;

      if (textarea) {

        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';

        if (textarea.offsetHeight > textarea.scrollHeight) {

          textarea.style.height = `${textarea.offsetHeight}px`;
        }
      }
    }
  }
}
